export const chart_errorbar_data_Fill = {
  "name": "--pf-chart-errorbar--data--Fill",
  "value": "transparent",
  "var": "var(--pf-chart-errorbar--data--Fill, transparent)"
};
export default chart_errorbar_data_Fill;